export const isEmptyStringOrStringifiedNull = (value: unknown): boolean => {
  return value === 'null' || value === '';
};
